// Сортировка таблицы со списками (SearchedTable). Раньше любая колонка сравнивалась как число
// (a - b): у текста это NaN, и колонки вроде «Название» не сортировались.

const isEmpty = (value) => value === null || value === undefined || value === "";

// Число в виде числа или строки («10.00» приходит из базы строкой): иначе null.
const NUMERIC = /^\s*[+-]?\d+(\.\d+)?\s*$/;
const asNumber = (value) => {
  if (typeof value === "number") return Number.isFinite(value) ? value : null;
  return typeof value === "string" && NUMERIC.test(value) ? Number(value) : null;
};

// Два значения: числа по величине, остальное как текст (без учёта регистра, с языком
// интерфейса, числа внутри текста по величине: «Склад 2» раньше «Склад 10»).
export const compareValues = (a, b) => {
  const numberA = asNumber(a);
  const numberB = asNumber(b);
  if (numberA !== null && numberB !== null) return numberA - numberB;
  return String(a).localeCompare(String(b), ["uk", "ru"], { sensitivity: "base", numeric: true });
};

// customSort для mui-datatables: пустые значения всегда в конце, в любом направлении.
export const sortRows = (rows, colIndex, order) => {
  const direction = order === "desc" ? -1 : 1;
  return rows.sort((a, b) => {
    const valueA = a.data[colIndex];
    const valueB = b.data[colIndex];
    if (isEmpty(valueA) && isEmpty(valueB)) return 0;
    if (isEmpty(valueA)) return 1;
    if (isEmpty(valueB)) return -1;
    return direction * compareValues(valueA, valueB);
  });
};
